import type { State } from "./state";
import type { GetterTree } from "vuex";

/**
 * Getters for store computed properties
 *
 * Getters shouldn't just access state, they should perform some sort of
 * transformation on the data or format it in some way.
 *
 * If you aren't doing logic just access the value on `$store.state` directly!
 *
 * @author Atomic Smash <developers@atomicsmash.co.uk>
 * @version 1.0.0
 */
export default {

    /**
     * The currency symbol to be used for this location
     *
     * @returns Currency symbol (£ or €)
     */
    currencySymbol: (state: State): "£"|"€" => {
        return state.place.currency === "GBP" ? "£" : "€";
    },

    /**
     * The label used for GA tracking when dates have been applied
     *
     * @return GA event label
     */
    eventLabel: ({ place }: State): string => {
        const onOrOff = place.availability_cal ? "on" : "off";

        return `${place.name} - ${place.id} - Availability ${onOrOff}`;
    },
} as GetterTree<State, State>;
